import { render } from "./CadastroPessoa.vue?vue&type=template&id=240c7482&scoped=true"
import script from "./CadastroPessoa.vue?vue&type=script&lang=js"
export * from "./CadastroPessoa.vue?vue&type=script&lang=js"

import "./CadastroPessoa.vue?vue&type=style&index=0&id=240c7482&lang=css"
import "./CadastroPessoa.vue?vue&type=style&index=1&id=240c7482&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240c7482"]])

export default __exports__